import { GridCellProps } from "@progress/kendo-react-grid"
import React from "react"
import { useNavigate, useParams } from "react-router"
import { useAppDispatch } from "../../../../app/hooks";
import { GridButton } from "../../../../components";
import { verifyApi } from "../../../../services/verifyService/verify-api";

function UserAssignmentViewCell(props: GridCellProps) {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { type, center } = useParams();

    // Don't render button in group header rows
    if (props.dataItem.aggregates || props.dataItem.items) {
        return <td></td>;
    }

    const handleClick = () => {
        const upn = props.dataItem.upn;
        navigate('/Worklist/' + center + '/' + type + '/user:' + encodeURIComponent(upn));
        dispatch(verifyApi.util.invalidateTags(['worklist']));
    };

    return (
        <td>
            <GridButton 
                variant="outlined" 
                size='small'
                color='primary'
                onClick={handleClick}
            >
                View
            </GridButton>
        </td>
    );
}

export { UserAssignmentViewCell }
